import { render } from "./ColliUscitaView.vue?vue&type=template&id=181d6348&scoped=true"
import script from "./ColliUscitaView.vue?vue&type=script&lang=js"
export * from "./ColliUscitaView.vue?vue&type=script&lang=js"

import "./ColliUscitaView.vue?vue&type=style&index=0&id=181d6348&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181d6348"]])

export default __exports__